import React from 'react';
import PropertySlider, { PropertySliderCounter, PropertySliderProps } from '../PropertySlider';
import SlideshowLinks, { SlideshowLinksProps } from '../SlideshowLinks';
import { Container, Wrapper, Content, SliderContainer } from './CrawfordsFarmSummary.style.pn';

export interface CrawfordsFarmSummaryProps {
  sliderProps: Omit<PropertySliderProps, 'maxHeight'> | null;
  slideshowLinksProps: SlideshowLinksProps;
  children: React.ReactNode;
}

const CrawfordsFarmSummary: React.FC<CrawfordsFarmSummaryProps> = ({ sliderProps, slideshowLinksProps, children }) => {
  return (
    <Container data-testid="crawfords-farm-summary">
      <Wrapper>
        <Content>
          {sliderProps && (
            <div>
              <SliderContainer>
                <SlideshowLinks {...slideshowLinksProps} />
                <PropertySlider {...sliderProps} maxHeight="350px" hideCounter scrollTop={1220} />
                <PropertySliderCounter
                  imageIndex={sliderProps.imageIndex}
                  images={sliderProps.images}
                  altCounter={sliderProps.altCounter}
                  centerImageCounter={sliderProps.centerImageCounter}
                  onCounterClick={sliderProps.onCounterClick}
                />
              </SliderContainer>
            </div>
          )}
          {children}
        </Content>
      </Wrapper>
    </Container>
  );
};

export default CrawfordsFarmSummary;
